import axios from 'axios';

/**
 * Gets details of a single Rule from Rules repository
 * @param {*} classificationSearchReq
 */
export async function getClassifications(classificationSearchReq) {
  const url = `${process.env.VUE_APP_JAVA_API_URL}/prodclass/classification`;
  let data;
  await axios
    .post(url, classificationSearchReq)
    .then((response) => {
      data = response;
    })
    .catch((err) => {
      console.log('getClassifications java api error', err); // eslint-disable-line no-console
    });
  return data;
}
/**
 * Gets details of single rule from rules repo. Skips to next question if there is a match
 * find with Question's keyword being supplied as a part of request payload.
 * @param {*} classificationSearchReq
 */
export async function getClassificationsUsingAttr(classificationSearchReq) {
  const url = `${process.env.VUE_APP_JAVA_API_URL}/prodclass/classificationByAttributes`;
  let data;
  await axios
    .post(url, classificationSearchReq)
    .then((response) => {
      data = response;
    })
    .catch((err) => {
      console.log('getClassificationsUsingAttr java api error', err); // eslint-disable-line no-console
    });
  return data;
}
export async function getClassificationsUsingAttrWrapper(classificationSearchReq) {
  const url = `${process.env.VUE_APP_JAVA_API_URL}/prodclass/classificationByAttributesWrapper`;
  let data;
  const headers = { 'Content-Type': 'application/json', 'X-Content-Type-Options': 'nosniff' };

  await axios
    .post(url, classificationSearchReq, { headers })
    .then((response) => {
      data = response;
    })
    .catch((err) => {
      console.log('getClassificationsUsingAttrWrapper java api error', err); // eslint-disable-line no-console
    });
  return data;
}
export async function getClassificationRationaleQuestions(classRationaleSearchReq) {
  const url = `${process.env.VUE_APP_JAVA_API_URL}/prodclass/rationaleReportQuestions`;
  let data;
  await axios
    .post(url, classRationaleSearchReq)
    .then((response) => {
      data = response;
    })
    .catch((err) => {
      console.log('getClassificationRationaleQuestions java api error', err); // eslint-disable-line no-console
    });
  return data;
}
export async function getClassificationRationaleQuestionsIVDR(classRationaleSearchReq) {
  const url = `${process.env.VUE_APP_JAVA_API_URL}/prodclass/rationaleReportQuestions/IVDR`;
  let data;
  await axios
    .post(url, classRationaleSearchReq)
    .then((response) => {
      data = response.data;
    })
    .catch((err) => {
      console.log('getClassificationRationaleQuestions java api error', err); // eslint-disable-line no-console
    });
  return data;
}
export async function postProdClassWorkFlowHeader(formData) {
  let result;
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/prodclass/productClassWorkflowAudit`, formData)
    .then((response) => {
      if (response.status === 200 && response.data) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('productClassWorkflowAudit java api error', err); // eslint-disable-line no-console
    });
  return result;
}
export async function prodClassRationaleEmailWorkFlow(formData) {
  let result;
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/prodclass/rationaleEmailWorkflow`, formData)
    .then((response) => {
      if (response.status === 200 && response.data) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('rationaleEmailWorkflow java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * prod-classification configuration  get api
 * to get the configuration json data from blob storage */
export async function getProdClassConfig() {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_AZURE_BLOB_URL}/prod-class/ProductClassification-config.json`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    })
    .catch((err) => {
      console.log('ProductClassification-config.json blob json error', err); // eslint-disable-line no-console
    });
  return result;
}

export async function printRationaleReport(formData) {
  let result;
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/prodclass/pdfreport`, formData)
    .then((response) => {
      if (response.status === 200 && response.data) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('printRationaleReport java api error', err); // eslint-disable-line no-console
    });
  return result;
}
/**
 * Creates an instance of Rationale report template data and response to questions.
 * @param {*} formData
 */
export async function createRationaleReport(formData) {
  let result;
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/prodclass/createrRationaleReportInstance`, formData)
    .then((response) => {
      if (response.status === 200 && response.data) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('createRationaleReport java api error', err); // eslint-disable-line no-console
    });
  return result;
}
export async function createRationaleReportIVDR(formData) {
  let result;
  await axios
    .post(
      `${process.env.VUE_APP_JAVA_API_URL}/prodclass/createrRationaleReportInstance/IVDR`,
      formData
    )
    .then((response) => {
      if (response.status === 200 && response.data) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('createRationaleReportIVDR java api error', err); // eslint-disable-line no-console
    });
  return result;
}
export async function createProductClassificationRationaleRequest(formData) {
  let result;
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/prodclass/classificationRationaleRequest`, formData)
    .then((response) => {
      if (response.status === 200 && response.data) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('createProductClassificationRationaleRequest java api error', err); // eslint-disable-line no-console
    });
  return result;
}
export async function getRationaleReportRequest(accountId) {
  let result = [];
  await axios
    .get(
      `${process.env.VUE_APP_JAVA_API_URL}/prodclass/classificationRationaleRequest/${accountId}`
    )
    .then((response) => {
      if (response.status === 200) result = response.data;
    })
    .catch((err) => {
      console.log('getRationaleReportRequest java api error', err); // eslint-disable-line no-console
    });
  return result;
}

export async function getClassificationSummaryByHeaderId(headerId) {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/prodclass/summary/headerId/${headerId}`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    })
    .catch((err) => {
      console.log('getClassificationSummaryByHeaderId java api error', err); // eslint-disable-line no-console
    });
  return result;
}
export async function getDetailsForSummaryPrint(accountId) {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/prodclass/summary/account/${accountId}`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    })
    .catch((err) => {
      console.log('getDetailsForSummaryPrint java api error', err); // eslint-disable-line no-console
    });
  return result;
}
export async function getRationaleHeaderInfo(headerId) {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/prodclass/rationaleHeader/headerId/${headerId}`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    })
    .catch((err) => {
      console.log('getRationaleHeaderInfo java api error', err); // eslint-disable-line no-console
    });
  return result;
}
export async function getClassificationRationaleData(accountId) {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/prodclass/activity/tracker/data/${accountId}`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    })
    .catch((err) => {
      console.log('getClassificationRationaleData java api error', err); // eslint-disable-line no-console
    });
  return result;
}
export async function upgradeRationaleReport(formData) {
  let result;
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/prodclass/upgradeRationaleReport`, formData)
    .then((response) => {
      if (response.status === 200 && response.data) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('upgradeRationaleReport java api error', err); // eslint-disable-line no-console
    });
  return result;
}
/**
 * @author -- Jaspal Dahliwal
 * @purpose
 */
export async function getProdClassUsageFlag(accountId) {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/prodclass/UsageQuota/${accountId}`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    })
    .catch((err) => {
      console.log('getProdClassUsageFlag java api error', err); // eslint-disable-line no-console
    });
  return result.data;
}
/**
 * @author -- Jaspal Dahliwal
 * @purpose
 */
export async function getActiveProdClassCount(accountId) {
  let result = 0;
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/prodclass/classificationcount/${accountId}`)
    .then((response) => {
      if (response.status === 200 && response.data)
        result = response.data.data.active_classification;
    })
    .catch((err) => {
      console.log('getActiveProdClassCount java api error', err); // eslint-disable-line no-console
    });
  return result;
}
